import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export const Footer = ({ texts }) => (
  <footer data-testid="site-footer" className="border-t border-obsidian-line bg-ink text-paper">
    <div className="ap-container grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:py-20">
      <div>
        <p className="font-display text-2xl font-black uppercase tracking-[0.14em]">
          Art<span className="text-signal">Part</span>
        </p>
        <p className="ap-stamp mt-4 leading-relaxed">
          St. Ruprecht an der Raab
          <br />
          Region Graz – Weiz – Gleisdorf
        </p>
        <p className="mt-4 text-sm text-concrete">Privates Studio · Termine nach Vereinbarung</p>
      </div>

      <div>
        <p className="ap-stamp mb-4 text-paper">Seite</p>
        <ul className="space-y-3 text-sm">
          <li>
            <a href="/#arbeiten" className="text-concrete transition-colors hover:text-signal">
              Ausgewählte Arbeiten
            </a>
          </li>
          <li>
            <a href="/#motive" className="text-concrete transition-colors hover:text-signal">
              Verfügbare Motive
            </a>
          </li>
          <li>
            <a href="/#anfrage" className="text-concrete transition-colors hover:text-signal">
              Projekt anfragen
            </a>
          </li>
          <li>
            <Link
              to="/entdecken"
              data-testid="footer-entdecken"
              className="text-concrete transition-colors hover:text-signal"
            >
              Entdeckerprojekt
            </Link>
          </li>
          <li>
            <a
              href="https://tattoogen.artpart.at/"
              data-testid="footer-tattoogen"
              className="text-concrete transition-colors hover:text-signal"
            >
              TattooGen
            </a>
          </li>
        </ul>
      </div>

      <div>
        <p className="ap-stamp mb-4 text-paper">Rechtliches</p>
        <ul className="space-y-3 text-sm">
          <li>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="text-concrete transition-colors hover:text-signal">
              Datenschutz
            </Link>
          </li>
          <li>
            <Link to="/impressum" data-testid="footer-impressum" className="text-concrete transition-colors hover:text-signal">
              Impressum
            </Link>
          </li>
          <li>
            <Link to="/versand" data-testid="footer-versand" className="text-concrete transition-colors hover:text-signal">
              Versand & Bestellanfrage
            </Link>
          </li>
          <li>
            <Link to="/pflege" data-testid="footer-pflege" className="text-concrete transition-colors hover:text-signal">
              Pflegeanleitung
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <p className="ap-stamp mb-4 text-paper">Kontakt</p>
        <a
          href={texts.instagram_url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="inline-flex items-center gap-2 text-sm text-concrete transition-colors hover:text-signal"
        >
          <Instagram size={16} /> {texts.instagram_handle}
        </a>
        <p className="mt-4 text-sm text-concrete">
          Anfragen ausschließlich über das Formular auf dieser Seite – René antwortet persönlich.
        </p>
      </div>
    </div>

    <div className="border-t border-obsidian-line">
      <div className="ap-container flex flex-col gap-2 py-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="ap-stamp">© {new Date().getFullYear()} ArtPart · René Ghavami</p>
        <p className="ap-stamp">AP · ARCHIV · STEIERMARK · AT</p>
      </div>
    </div>
  </footer>
);
